import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  Button as ModalButton,
  Col,
  Collapse,
  FormGroup,
  Input as BootstrapInput,
  Label,
  Modal,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap';
import { ToastContainer, toast } from 'react-toastify';
import ReactPasswordStrength from 'react-password-strength';

import { getEntity } from '../../../services/entity/entity-service';

import Button from '../../components/button/button';
import Input from '../../components/input/input';
import InputSelect from '../../components/input-select/input-select';
import FormSection from '../../components/form-section/form-section';

import { getOrganizations } from '../../../modules/organization';
import { setPageTitle } from '../../../modules/application/pages';
import { getRoles } from '../../../modules/system/role';
import { getOccupations } from '../../../modules/occupation';

import Constants from '../../../constants/constants';
import { createUser, getUser, resetUserState, updateUser } from '../../../modules/user';
import { /*createUser, getUser,*/ loginExists /* resetUserState, updateUser*/ } from '../../../modules/user_api';
import SplitIOTreatment from '../../splitio/splitioTreatment';
import { Tooltip } from 'react-tippy';
import styled from 'styled-components';

import './team-member-form.css';

const InputWrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
`;

const StyledInput = styled(Input)`
  flex-grow: 1;
`;

const StyledButton = styled(Button)`
  flex-shrink: 1;
  margin-top: 24px;
`;

class TeamMemberForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      first_name: '',
      last_name: '',
      phone_number: '',
      occupation: -1,
      login: '',
      email: '',
      password: '',
      organizations: '',
      roles: '',

      isOpenPasswordChange: false,
      _password: {},
      _passwordConfirm: {},

      playerCount: 0,
      showModal: false,
      isEdit: false,

      // modification by super only
      roleDisplay: '',
      roleId: '',
      organizationDisplay: '',
      organizationId: '',
      otpPhoneTwoDigits: null,

      routeId: this.props.match.params.id,

      send_usage_email: false,
    };

    this.submitTeamMember = this.submitTeamMember.bind(this);
    this.setFormVariables = this.setFormVariables.bind(this);

    this.setFormVariables();
  }

  setFormVariables() {
    const { params } = this.props.match;
    const { user } = this.props;

    this.title = this.props.location.title || 'Team Member Form';
    this.isCurrentUser = params && user && parseInt(params.id, 10) === user.id;
    this.navigationPath = this.isCurrentUser ? '/' : '/teamMembers';
    this.toastMessage = this.isCurrentUser ? 'my profile' : 'team member';
    this.submitButtonLabel = 'Add';
  }

  componentDidMount() {
    this.props.dispatch(resetUserState());

    this.props.dispatch(setPageTitle(this.title));
    this.props.dispatch(getOrganizations());
    this.props.dispatch(getRoles());
    this.props.dispatch(getOccupations());

    if (this.props.match.params.id) {
      this.props.dispatch(getUser(this.props.match.params.id));
      this.submitButtonLabel = 'Save';
    }
  }

  componentDidUpdate() {
    const { user, otpPhoneTwoDigits } = this.props;
    if (user && user.id !== this.state.id) {
      this.setState({
        ...user,
        otpPhoneTwoDigits,
        playerCount: user.players.length,
      });

      if (user.organizations && user.organizations.length > 0) {
        this.setState({ organizationId: user.organizations[0] });
      }
      if (user.roles && user.roles.length > 0) {
        this.setState({ roleId: user.roles[0] });
      }
      this.setState({ isEdit: true });
    }

    if (this.state.routeId !== this.props.match.params.id) {
      this.setState({ routeId: this.props.match.params.id });
      this.setFormVariables();
      console.error('   ~~~ TEAM MEMBER FORM this state was not expected');
    }
  }

  validateFields = () => {
    const { roleId, first_name, last_name } = this.state;

    if (roleId === '') {
      toast.error('Please give your team member a Role.', {
        position: toast.POSITION.TOP_CENTER,
      });
    } else if (first_name === '') {
      toast.error('Please give your team member a First Name.', {
        position: toast.POSITION.TOP_CENTER,
      });
    } else if (last_name === '') {
      toast.error('Please give your team member a Last Name.', {
        position: toast.POSITION.TOP_CENTER,
      });
    } else {
      return true;
    }
  };

  async submitTeamMember(isChangePasswordUsername) {
    const { dispatch } = this.props;
    const {
      first_name,
      last_name,
      phone_number,
      occupation,
      organizationId,
      roleId,
      login,
      email,
      isEdit,
      _password,
      _passwordConfirm,
      id,
      send_usage_email,
    } = this.state;
    let password = null;

    if (!this.validateFields()) {
      return;
    }

    if (_password.password && _password.password.length > 0) {
      if (_password.password !== _passwordConfirm.password) {
        toast.error('Passwords do not match.', {
          position: toast.POSITION.TOP_CENTER,
        });
        return;
      }
      if (_password.score < 2) {
        toast.error('Password is not strong enough.', {
          position: toast.POSITION.TOP_CENTER,
        });
        return;
      }
      password = _password.password;
    }

    if (!isEdit && password === null) {
      toast.error('New Team Member must have a password.', {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }

    const _loginExists = await loginExists(login, id);

    if (_loginExists.data.loginExists) {
      toast.error('Login assigned to another user.', {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }

    const passwordHasChanged = password !== null && this.props.user.password !== password;
    const usernameHasChanged = this.props.user.login !== login;

    if (!isChangePasswordUsername && isEdit && (passwordHasChanged || usernameHasChanged)) {
      this.setState({ showModal: true });
      return;
    }

    const user = { first_name, last_name, phone_number, occupation, login, email, send_usage_email };

    user.organizations = [organizationId ? parseInt(organizationId, 10) : parseInt(this.props.organization)];
    user.roles = [parseInt(roleId, 10)];

    if (isChangePasswordUsername || !isEdit) {
      user.password = password;
    }

    if (isEdit) {
      await getEntity(dispatch, updateUser(this.props.user.id, user));

      this.props.history.push(`${this.navigationPath}?message=Updated ${this.toastMessage}!`);
    } else {
      await getEntity(dispatch, createUser(user));

      this.props.history.push(
        `${this.navigationPath}?message=Added ${this.toastMessage}! ${this.state.first_name} ${this.state.last_name}`
      );
    }
  }

  render() {
    return (
      <div className="px-1">
        <FormSection component={this.buildTeamMemberForm()} />
        <ToastContainer />
      </div>
    );
  }

  setPassword = (_password) => {
    this.setState({ _password });
  };

  setPasswordConfirm = (_passwordConfirm) => {
    this.setState({ _passwordConfirm });
  };

  async update_UsageDataEmailStatus() {
    const { send_usage_email } = this.state;
    const new_UsageDataEmail = !send_usage_email;
    await this.setState({
      send_usage_email: new_UsageDataEmail,
    });
  }

  getRoleByID(roleID) {
    const { roles } = this.props;
    let currentRole;
    roleID = parseInt(roleID, 10);

    for (let i = 0; i < roles.length; i++) {
      currentRole = roles[i];
      if (currentRole.id === roleID) {
        return currentRole;
      }
    }
  }

  checkIfMyRoleIsAdmin(myRole) {
    return (
      myRole &&
      (myRole.level === Constants.REGIONAL_ADMIN_ROLE_LEVEL ||
        myRole.level === Constants.BUSINESS_GROUP_ADMIN_ROLE_LEVEL)
    );
  }

  handleOTPChange() {
    const currURL = new URL(window.location.href);
    const purl = encodeURI(currURL.origin);
    window.location.href = `${purl}/otp/change`;
  }

  buildTeamMemberForm() {
    const { isEdit, isOpenPasswordChange, send_usage_email, roleId } = this.state;

    let myRole;
    let amIAdmin;
    if (roleId !== '') {
      try {
        myRole = this.getRoleByID(roleId);
        amIAdmin = this.checkIfMyRoleIsAdmin(myRole);
      } catch (e) {
        console.error(e);
      }
    }

    const toSendDataUsageEmail = (
      <span>
        <Tooltip title="Currently, automated emails will be sent to the given email address">
          <span className="restore_tooltip">
            <i className="fa fa-info-circle"></i>
          </span>
        </Tooltip>
        Send Data Usage Email
      </span>
    );

    const doNOTSendDataUsageEmail = (
      <span>
        <Tooltip title="Currently, automated emails will NOT be sent to the given email address">
          <span className="restore_tooltip">
            <i className="fa fa-info-circle"></i>
          </span>
        </Tooltip>
        Send Data Usage Email
      </span>
    );

    return (
      <div className="mp-0 container-fluid">
        <Col md={12} className="pl-1 text-left">
          <FormSection
            sectionLabel="Organization Information"
            sectionInfo={this.state.isEdit ? `Number of Players: ${this.state.playerCount}` : ''}
            component={
              <Col className="mp-0">
                <Row className="mp-0 p-2">
                  <Col className="mp-0">{this.roleInput()}</Col>

                  <Col className="mp-0">{this.occupationOptions()}</Col>

                  <Col md={6} className="mp-0">
                    {this.organizationInput()}
                  </Col>
                </Row>
              </Col>
            }
          />

          <FormSection
            sectionLabel="Personal Information"
            component={
              <Col className="mp-0">
                <Row className="mp-0 p-2">
                  <Col md={6} className="mp-0">
                    <Input
                      name="firstName"
                      value={this.state.first_name}
                      onChange={(first_name) => {
                        this.setState({ first_name });
                      }}
                      label="First Name"
                      formgroupclassname="m-0 px-2"
                    />
                  </Col>

                  <Col md={6} className="mp-0">
                    <Input
                      name="lastName"
                      value={this.state.last_name}
                      onChange={(last_name) => {
                        this.setState({ last_name });
                      }}
                      label="Last Name"
                      formgroupclassname="m-0 px-2"
                    />
                  </Col>
                </Row>

                <Row className="mp-0 p-2">
                  <Col md={6} className="mp-0">
                    <Input
                      name="phoneNumber"
                      value={this.state.phone_number}
                      onChange={(phone_number) => {
                        this.setState({ phone_number });
                      }}
                      label="Phone Number"
                      type="tel"
                      formgroupclassname="m-0 px-2"
                    />
                  </Col>

                  <Col md={6} className="mp-0">
                    <SplitIOTreatment
                      featureName={'DC-1945-OTP-per-business-group'}
                      treatmentValue="on"
                      trafficType="business-group"
                    >
                      {(treatment) => {
                        if (treatment === 'on' && this.state.otpPhoneTwoDigits?.length) {
                          return (
                            <InputWrapper>
                              <StyledInput
                                defaultValue={`(###) ###-##${this.state.otpPhoneTwoDigits}`}
                                label="OTP Phone Number"
                                type="tel"
                                formgroupclassname="m-0 px-2"
                                disabled
                              />

                              <StyledButton
                                type="button"
                                text="Change OTP Phone Number"
                                onClick={() => {
                                  this.handleOTPChange();
                                }}
                              />
                            </InputWrapper>
                          );
                        } else {
                          return <></>;
                        }
                      }}
                    </SplitIOTreatment>
                  </Col>
                </Row>

                <Row className="mp-0 p-2">
                  <Col md={6} className="mp-0">
                    <Input
                      name="login"
                      value={this.state.login}
                      onChange={(login) => {
                        this.setState({ login });
                      }}
                      label="Login"
                      type="text"
                    />
                  </Col>

                  <Col md={6} className="mp-0">
                    <Input
                      name="email"
                      value={this.state.email}
                      onChange={(email) => {
                        this.setState({ email });
                      }}
                      label="Email"
                      type="email"
                    />
                  </Col>
                </Row>

                {amIAdmin && (
                  <Row className="my-0 py-0 m-2">
                    {!send_usage_email && (
                      <Button
                        size="sm"
                        color="default"
                        style={{ fontSize: 25 }}
                        outline
                        className="mr-1 home_play_button"
                        iconClass="fa-toggle-on fa-flip-horizontal home_play_toggle"
                        onClick={this.update_UsageDataEmailStatus.bind(this)}
                        text={doNOTSendDataUsageEmail}
                      />
                    )}

                    {send_usage_email && (
                      <Button
                        size="sm"
                        color="danger"
                        style={{ fontSize: 25 }}
                        outline
                        className="mr-1 home_play_button"
                        iconClass="fa-toggle-on home_play_toggle"
                        onClick={this.update_UsageDataEmailStatus.bind(this)}
                        text={toSendDataUsageEmail}
                      />
                    )}
                  </Row>
                )}

                <Row className="mp-0">
                  {isEdit && (
                    <Row className="mp-0 container-fluid">
                      <p
                        className="mp-0 font-italic font-weight-bold secondary-color pointer"
                        onClick={() => {
                          this.setState({ isOpenPasswordChange: !isOpenPasswordChange });
                        }}
                      >
                        <i className={`mx-2 fa ${isOpenPasswordChange ? 'fa-caret-down' : 'fa-caret-right'}`} />
                        Change Password
                      </p>
                    </Row>
                  )}

                  <Collapse isOpen={!isEdit || isOpenPasswordChange} className="mp-0 col-md-6">
                    <FormGroup className="mx-2">
                      <Label className="font-weight-bold mb-0" for="inputPassword1">
                        Password
                      </Label>

                      <ReactPasswordStrength
                        minLength={6}
                        style={{ fontSize: 12 }}
                        className="rounded"
                        changeCallback={this.setPassword}
                        inputProps={{
                          id: 'inputPassword1',
                          type: this.state.showPassword ? 'text' : 'password',
                          style: { height: 30 },
                          autoComplete: 'new-password',
                        }}
                      />
                    </FormGroup>

                    <FormGroup className="m-2">
                      <Label className="font-weight-bold mb-0" for="inputPassword1">
                        Confirm Password
                      </Label>

                      <ReactPasswordStrength
                        ref={(ref) => (this.ReactPasswordStrength = ref)}
                        minLength={6}
                        style={{ fontSize: 12 }}
                        className="rounded"
                        changeCallback={this.setPasswordConfirm}
                        inputProps={{
                          id: 'inputPassword2',
                          autoComplete: 'new-password',
                          type: this.state.showPassword ? 'text' : 'password',
                          style: { height: 30 },
                        }}
                      />
                    </FormGroup>
                  </Collapse>
                </Row>
              </Col>
            }
          />
        </Col>

        <div className="mr-3 mt-3 mb-2 text-right">
          <Button
            className="ml-1"
            text="Cancel"
            outline
            onClick={() => {
              this.props.history.push(this.navigationPath);
            }}
            color="info"
          />

          <Button
            className="ml-1"
            text={this.submitButtonLabel}
            onClick={() => {
              this.submitTeamMember(false);
            }}
            color="primary"
          />
        </div>

        <Modal isOpen={this.state.showModal} className={this.props.className} backdrop={this.state.backdrop}>
          <ModalHeader>Are you sure you want to change your password and/or login email?</ModalHeader>

          <ModalFooter>
            <ModalButton
              className="ml-3"
              color="primary"
              onClick={() => {
                this.submitTeamMember(true);
              }}
            >
              Yes
            </ModalButton>

            <ModalButton
              className="ml-3"
              color="secondary"
              onClick={() => {
                this.setState({ showModal: false });
              }}
            >
              Do Not Change
            </ModalButton>
          </ModalFooter>
        </Modal>
      </div>
    );
  }

  occupationOptions = () => {
    const { occupations } = this.props;
    const _occupations = [{ id: -1, name: 'Select Occupation' }, ...occupations];

    const occupationOptions = _occupations.map((occupation, i) => {
      return (
        <option key={i} value={occupation.id}>
          {occupation.name}
        </option>
      );
    });

    return (
      <InputSelect
        name="occupation"
        value={this.state.occupation}
        onChange={(occupation) => {
          this.setState({ occupation });
        }}
        label="Occupation"
        options={occupationOptions}
      />
    );
  };

  organizationInput = () => {
    const { isSuperRole } = this.props;

    return isSuperRole ? (
      <InputSelect
        name="organizationId"
        value={this.state.organizationId}
        onChange={(organizationId) => {
          this.setState({ organizationId });
        }}
        label="Organization Name"
        options={this.organizationOptions()}
      />
    ) : (
      <div>
        <Input name="organizationDisplay" value={this.organizationName()} label="Organization Name" readOnly="true" />
        <BootstrapInput name="organizationId" value={this.state.organizationId} type="hidden" />
      </div>
    );
  };

  organizationOptions = () => {
    const { organizations } = this.props;
    const options = [
      <option key="organizationDefault" value="">
        ( Please Select )
      </option>,
    ];

    options.push(
      organizations.map((organization) => {
        return (
          <option key={`${organization.id}_${organization.name}`} value={organization.id}>
            {organization.name}
          </option>
        );
      })
    );

    return options;
  };

  organizationName = () => {
    const teamMemberOrganization = this.getTeamMemberOrganization();
    return teamMemberOrganization.name;
  };

  getTeamMemberOrganization() {
    const { organizations } = this.state;

    const organizationId =
      organizations && organizations.length > 0 ? organizations[0] : this.props.currentUserOrganization;

    const teamMemberOrganization =
      this.props.organizations &&
      this.props.organizations.filter((organization) => {
        return organization.id === organizationId;
      });

    return teamMemberOrganization && teamMemberOrganization.length !== 0 && teamMemberOrganization[0];
  }

  roleInput = () => {
    return (
      <InputSelect
        name="roleId"
        value={this.state.roleId}
        onChange={(roleId) => {
          this.setState({ roleId });
        }}
        label="Role"
        options={this.props.roles && this.roleOptions()}
      />
    );
  };

  roleOptions = () => {
    const { roles, user } = this.props;
    const { params } = this.props.match;

    const options = [
      <option key="roleDefault" value="">
        ( Please Select )
      </option>,
    ];

    const ROLE_LEVEL_TO_IGNORE = 3;

    for (const index in roles) {
      const role = roles[index];

      if (
        role.level !== ROLE_LEVEL_TO_IGNORE ||
        (user && user.roles && user.roles[0] === role.id && params && user.id === parseInt(params.id, 10))
      ) {
        options.push(
          <option key={`${role.id}_${role.name}`} value={role.id}>
            {role.name}
          </option>
        );
      }
    }
    return options;
  };
}

const withState = connect((state) => {
  const { organization, role, user, occupation } = state;
  const playerCount = 0;

  const roles =
    role &&
    user &&
    role.roles &&
    role.roles.filter((role) => {
      return user.roleLevel <= role.level;
    });

  return {
    user: user.user,
    organization: user.organization,
    organizations: organization.organizations,
    roles: roles,
    playerCount: playerCount,
    isSuperRole: user.isSuperRole,
    currentUserOrganization: user.organization,
    occupations: occupation.list,
    otpPhoneTwoDigits: user.otpPhoneTwoDigits,
  };
});

export default withRouter(withState(TeamMemberForm));
